import { AestheticMedicineExperienceMT } from "./v1";

export const aestheticMedicineExperienceMTOptions = Object.entries(AestheticMedicineExperienceMT)
	.filter(([, value]) => {
		return isNaN(Number(value));
	})
	.map(([value, label]) => {
		return { value, label };
	});
